import more_logo from "../assets/img/more-logo.svg";

export const GLOBAL_CONSTANTS = {
  EMBEDDED_VALUE: "EMBEDDED",
  REDIRECT_VALUE: "REDIRECT",
  MESSAGE_VALUE: "MESSAGE",
  ERROR_VALUE: "ERROR",
  //
  MORE_UNITELLER_LOGO: more_logo,
};

export const ALERT_TYPES = {
  success: "success",
  error: "danger",
};

export const MANDATORY_FIELD_TYPES = {
  string: 1,
  number: 2,
  date: 3,
  select: 4,
  catalogue: 5,
};

export const AGGREGATORS_ENUM = {
  // ids de agregadores que tengamos que ocultar QR o boton copy u otra operacion especial
  treviso: 16,
  newPay: 33,
  newPayProd: 48,
  oz: 36,
};
